import React from 'react'
import { StyledSelect } from './styled'
import { SelectProps } from './types'

export const Select: React.FC<SelectProps> = (props: SelectProps) => {
  return <StyledSelect {...props} />
}
